import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

import './sort.scss';

const Sort = function (
    {
        columns = [],
        default_order_by = 'id',
        default_order_direction = 'asc'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();
    const order_by = searchParams.has('order_by') ? searchParams.get('order_by') : default_order_by;
    const order_direction = searchParams.has('order_direction') ? searchParams.get('order_direction') : default_order_direction;

    const setOrderBy = function (order_by) {
        searchParams.set('order_by', order_by);
        setSearchParams(searchParams);
    }
    const setOrderDirection = function (order_direction) {
        searchParams.set('order_direction', order_direction);
        setSearchParams(searchParams);
    }

    return (
        <div className="sort">
            <div className='order-by'>Order by:</div>
            <select
                className='sort-column-selector'
                value={order_by}
                onChange={(event) => setOrderBy(event.target.value)}
            >
                {columns.map(column => {
                    return <option key={column.key} value={column.key}>{column.name}</option>
                })}
            </select>
            <div>Direction:</div>
            <select
                className='sort-value-selector'
                value={order_direction}
                onChange={(event) => setOrderDirection(event.target.value)}
            >
                <option value='asc'>ASC</option>
                <option value='desc'>DESC</option>
            </select>
        </div>
    );
}

Sort.propTypes = {
    entity: PropTypes.string,
    columns: PropTypes.array.isRequired,
    default_order_by: PropTypes.string,
    default_order_direction: PropTypes.oneOf(['asc', 'desc'])
};

export default Sort;
